import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media.js";

const Container = styled.div`
    max-width: 100vw;
    display: flex;
    flex-direction: column;
    padding-bottom: 15px;
`;

const Label = styled.label`
    color: #30343a;
    width: 100%;
    font-size: 15px;
    padding-left: 5px;
    padding-bottom: 8px;

    ${device.tablet} {
        font-size: 15px;
    }

    ${device.mobile} {
        font-size: 13px;
    }
`;

const InputBox = styled.input`
    box-sizing: border-box;
    position: relative;
    width: 450px;
    height: 45px;
    padding: 9px 20px;
    color: #737373;
    border: none;
    font-size: 15px;
    background-color: rgba(238, 238, 238, 0.5);

    &::placeholder {
        color: #bababa;
        font-size: 14px;
    }
    ${device.tablet} {
        max-width :100vw;
        width: 100%;
    }
    ${device.mobile} {
        max-width :100vw;
        width: 100%;
    }
`;

const Required = styled.span`
    font-size: 12px;
    margin-left: 1px;
    color: #ff7171;


    ${device.mobile} {
        font-size: 12px;
    }
`;
const Input = ({label, name, type, onChange, placeholder, }) => {
    return (
        <Container>
                <Label htmlFor={name}>{label}<Required>*</Required></Label>
                <InputBox
                    name={name}
                    type={type}
                    onChange={(e) => onChange(e)}
                    placeholder={placeholder}
                    maxLength={50}

                />

        </Container>
    );
};

export default Input;
